import React from "react";

const ConstructionDecore = ({ isRight = true, className }) => {
    return (
        <>
            <div
                className={`min-w-[346px] min-h-[150px] md:min-h-[348.86px] outline outline-[1px] outline-earthYellow-500 opacity-60 dark:opacity-40 dark:outline-earthYellow-200 absolute  ${
                    isRight
                        ? " -right-[350px] lg:-right-[500px]"
                        : " -left-[350px] lg:-left-[500px]"
                }   -z-10 top-24 ${className}`}
            />
            <div
                className={`min-w-[346px] min-h-[150px] md:min-h-[348.86px] outline outline-[1px] outline-earthYellow-500 opacity-60 dark:opacity-40 dark:outline-earthYellow-200 absolute  ${
                    isRight
                        ? "  -right-[300px] lg:-right-[450px]"
                        : " -left-[300px] lg:-left-[450px]"
                }   top-36 -z-10 ${className}`}
            />
        </>
    );
};

export default ConstructionDecore;
